module.exports = __webpack_public_path__ + "img/load_year_cons.1ceb0c9c.svg";